// src/components/StockPicker.jsx
// 종목명 자동완성 피커 → {n,c,m}. (AddPairModal의 피커와 동일 로직, 공용화)
import React, { useState } from "react";
import { searchStocks } from "../lib/krStocks";

const sel = { width: "100%", padding: "9px 12px", borderRadius: 8, border: "1px solid #e2e2e2", fontSize: 13, boxSizing: "border-box" };
const MKT_LAB = { KS: "코스피", KQ: "코스닥", KR: "미분류" };

export default function StockPicker({ value, onPick, onClear }) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const matches = open && q ? searchStocks(q) : [];

  if (value) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <div style={{ flex: 1, padding: "9px 12px", borderRadius: 8, border: "1px solid #e2e2e2", fontSize: 13, background: "#f7f8fa" }}>
          <b>{value.n}</b> <span style={{ color: "#999" }}>({value.c})</span>
        </div>
        <select value={value.m} onChange={e => onPick({ ...value, m: e.target.value })}
          style={{ ...sel, width: 90 }} title="시장 (가격 이상하면 바꿔보세요)">
          <option value="KS">코스피</option>
          <option value="KQ">코스닥</option>
        </select>
        <button onClick={onClear} style={{ background: "none", border: "none", cursor: "pointer", color: "#bbb", fontSize: 16 }}>✕</button>
      </div>
    );
  }
  return (
    <div style={{ position: "relative" }}>
      <input style={sel} placeholder="종목명 입력 (예: 삼성SDI)" value={q}
        onChange={e => { setQ(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {matches.length > 0 && (
        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 10, background: "#fff", border: "1px solid #e2e2e2", borderRadius: 8, marginTop: 3, maxHeight: 240, overflowY: "auto", boxShadow: "0 6px 20px rgba(0,0,0,0.1)" }}>
          {matches.map(m => (
            <div key={m.c} onMouseDown={() => { onPick(m); setQ(""); setOpen(false); }}
              style={{ padding: "8px 12px", cursor: "pointer", fontSize: 13, display: "flex", justifyContent: "space-between" }}
              onMouseEnter={e => e.currentTarget.style.background = "#f2f5fb"}
              onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
              <span><b>{m.n}</b> <span style={{ color: "#aaa" }}>{m.c}</span></span>
              <span style={{ color: "#bbb", fontSize: 11 }}>{MKT_LAB[m.m]}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
